import {
  QueryStatusError,
  QueryStatusIdle,
  QueryStatusLoading,
  QueryStatusSuccess,
} from './queryStatus';

export interface TaskStatusBase<T, E> {
  promise?: Promise<T>;
  data?: T;
  error?: E | null;
}

export interface TaskStatusIdle<T, E>
  extends TaskStatusBase<T, E>,
    QueryStatusIdle {
  error?: null;
}

export interface TaskStatusLoading<T, E>
  extends TaskStatusBase<T, E>,
    QueryStatusLoading {
  error?: null;
  promise: Promise<T>;
}

export interface TaskStatusError<T, E>
  extends TaskStatusBase<T, E>,
    QueryStatusError {
  error: E;
}

export interface TaskStatusSuccess<T, E>
  extends TaskStatusBase<T, E>,
    QueryStatusSuccess {
  error?: null;
  data: T;
}

export type TaskStatus<T, E> =
  | TaskStatusIdle<T, E>
  | TaskStatusLoading<T, E>
  | TaskStatusError<T, E>
  | TaskStatusSuccess<T, E>;
